
export const api = {
    host:  process.env.REACT_APP_API_URL,
    login: 'api/v1/login',
    loginWH: 'api/v1/login-via-code',
    registration: 'api/v1/register',
    forgotPassword: 'api/v1/forgot-password',
    resetPassword: 'api/v1/reset-password',
    invitationCode: 'api/v1/invitation',
    systemUpdates: 'api/v1/system-updates',
    logout: 'api/v1/logout',
    cabinet: {
        userData: 'api/v1/user',
        dashboard: 'api/v1/dashboard',
        notifications: 'api/v1/notifications',
        withdrawals: 'api/v1/withdrawals',
        referralWithdrawals: 'api/v1/referral-withdrawals',
        balanceTopup: 'api/v1/balance/topup',
        directTopup: 'api/v1/balance/direct-topup',
        preSaleMain: 'api/v1/token-sale',
        changePassword: 'api/v1/user/password',
        changeWallet: 'api/v1/user/wallet',
        changeEmail: 'api/v1/user/email',
        buyTokenData: 'api/v1/checkout/wallet',
        lastLog: 'api/v1/user/last-login',
        logout: 'api/v1/user/logout',
        logoutOthers: 'api/v1/user/logout-others',
        orderHistory: 'api/v1/orders',
        activeOrder: 'api/v1/checkout',
        referrals: 'api/v1/user/referrals',
        setReferrer: 'api/v1/user/referrer',
        earlyAccess: 'api/v1/user/early-access',
        referralTransfers: 'api/v1/user/referral-transfers',
        capsuleOffer: 'api/v1/capsule/offer',
        capsulePurchase: 'api/v1/capsule/purchase',
        capsuleStats: 'api/v1/capsule/stats',
        questionnaire: 'api/v1/capsule/questionnaire',
        questionBlocks: 'api/v1/question-blocks',
        capsuleNotes: 'api/v1/capsule/notes',
        capsuleFiles: 'api/v1/capsule/files',
        avatar: 'api/v1/avatar',
        voice: 'api/v1/voice',
        energy: 'api/v1/energy',
        energyUnlock: 'api/v1/energy/unlock',
        metapersonSession: 'api/v1/metaperson/session',
        avatarImport: 'api/v1/avatar/import',
        energyPackages: 'api/v1/energy/packages',
        energyPurchase: 'api/v1/energy/purchase',
        conversationAsk: 'api/v1/conversation/ask',
        conversationSpeak: 'api/v1/conversation/speak',
        conversations: 'api/v1/conversations',
        capsuleSeal: 'api/v1/capsule/seal',
        storage: 'api/v1/storage',
        storagePackages: 'api/v1/storage/packages',
        storagePurchase: 'api/v1/storage/purchase'
    }
}